// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "e1b9d4d9",
    "hash": "e1b9d4d9",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "e1b9d4d9",
    "semverString": null,
    "version": "2026.5.0.11"
};
/* tslint:enable */
